import cm from 'classnames';
import styles from './_tooltip.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const TooltipHelp = ({ className, children, ...rest }: Props) => {
  return (
    <div {...rest} className={cm(styles.TooltipHelp, className)}>
      <h3 className={styles.TooltipHelp__label}>
        <span>Help Mode</span>
      </h3>
      {children}
    </div>
  );
};
